import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import SearchIcon from '@mui/icons-material/Search'
import DeliveryChrgTable from './DeliveryChrgTable'
import { connect } from 'react-redux'
import { updateModal, updateAlertError } from '../../../../../store/common/common_action'
import { getDeliveryChrg, getDeliveryExtraHamaliChrg, updateDeliveryChrg,updateDeliveryExtraHamaliCharge } from '../../../../../store/generalSetting/GSAction'
import * as mdt from '../../../../common/modaltypes'
import DeliveryChrgModal from './DeliveryChrgModal'
import { useState } from 'react'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import { useEffect } from 'react'
import ConfirmModal from './ConfirmModal'
import { deliveryTypeList, chargeTypeList, hamaliTypeList } from '../../GSConstants'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const DeliveryCharges = (props) => {
  const {
    data: { common },
    updateModal,
    updateAlertError,
    getDeliveryChrg,
    updateDeliveryChrg,
    getDeliveryExtraHamaliChrg,
    updateDeliveryExtraHamaliCharge
  } = props
  const { loginData, showModal, modalType, cnsgnmntTypes } = common
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const mapTranslated = (list = []) =>
    list.map((item) => ({ ...item, name: tr(item.translationKey, item.name) }))
  const translatedDeliveryTypes = mapTranslated(deliveryTypeList)
  const translatedChargeTypes = mapTranslated(chargeTypeList)
  const translatedHamaliTypes = mapTranslated(hamaliTypeList)
  const consignmentTypesWithAll = cnsgnmntTypes.length > 0
    ? [{ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') }, ...cnsgnmntTypes]
    : []
  const [selConsignmentType, setSelConsignmentType] = useState({ ConsignmentSubTypeID: 0, SubType: tr('gsAll', 'All') })
  const [selDeliveryType, setSelDeliveryType] = useState(deliveryTypeList[0])
  const [consignmentTypeOpt, setConsignmentTypeOpt] = useState([])
  const [reportData, setReportData] = useState([])
  const [hamaliType, setHamaliType] = useState(hamaliTypeList?.[0])
  const [chargeType, setChargeType] = useState(chargeTypeList?.[0])
  useEffect(() => {
    focusElemnt('Select_Consignment_Type')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      getDeliveryChrgList()
    }
  }, [loginData])
  useEffect(() => {
    setSelDeliveryType((prev) => translatedDeliveryTypes.find((item) => item.id === prev?.id) || translatedDeliveryTypes[0])
    setChargeType((prev) => translatedChargeTypes.find((item) => item.id === prev?.id) || translatedChargeTypes[0])
    setHamaliType((prev) => translatedHamaliTypes.find((item) => item.id === prev?.id) || translatedHamaliTypes[0])
    setSelConsignmentType((prev) =>
      consignmentTypesWithAll.find((item) => item.ConsignmentSubTypeID === prev?.ConsignmentSubTypeID) || prev
    )
  }, [translations])
  useEffect(()=>{
    focusElemnt('Select_Consignment_Type')
  },[])
  const addDeliveryChrgModal = () => {
    const data = {
      isUpdate: false,
      headText: tr('gsSuccess', 'Success !!!'),
      isEdit:false,
      loginData: loginData,
      ConsignmentTypeList: cnsgnmntTypes,
      ChargeTypeList: chargeTypeList,
      HamaliTypeList: hamaliTypeList,
    }
    return (
      <DeliveryChrgModal
        data={data}
        updateModal={updateModal}
        updateAlertError={updateAlertError}
        getDeliveryChrg={getDeliveryChrg}
        getDeliveryExtraHamaliChrg={getDeliveryExtraHamaliChrg}
        updateDeliveryChrg={updateDeliveryChrg}
        updateDeliveryExtraHamaliCharge={updateDeliveryExtraHamaliCharge}
        getDeliveryChrgList={getDeliveryChrgList}
      />
    )
  }
  const updateDeliveryChrgModal = () => {
    const data = {
      isUpdate: true,
      headText: tr('gsUpdated', 'Updated !!!'),
      isEdit:true,
      loginData: loginData,
      ConsignmentTypeList: consignmentTypeOpt,
      ChargeTypeList: chargeTypeList,
      HamaliTypeList: hamaliTypeList,
    }
    return (
      <DeliveryChrgModal
        data={data}
        updateModal={updateModal}
        updateAlertError={updateAlertError}
        getDeliveryChrg={getDeliveryChrg}
        getDeliveryExtraHamaliChrg={getDeliveryExtraHamaliChrg}
        updateDeliveryChrg={updateDeliveryChrg}
        updateDeliveryExtraHamaliCharge={updateDeliveryExtraHamaliCharge}
        getDeliveryChrgList={getDeliveryChrgList}
        reportData={reportData}
      />
    )
  }
  const getDeliveryChrgList = () => {
    setReportData([])
    if (selConsignmentType === '' || selConsignmentType === ' ') {
      updateAlertError({ show: true, msg: tr('gsSelCnsErr', 'Please Select Consignment Type'), nextId: 'Select_Consignment_Type' })
    } else {
      if (hamaliType.id === 0) {
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selDeliveryType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          DeliveryType: selDeliveryType?.id,
          ChargeType: chargeType?.id
        }
        getDeliveryChrg(body)
          .then((res) => {
            if (res.status === 'Success') {
              setReportData(res.Data.Table)
              setConsignmentTypeOpt(
                removeDuplicatesFromArray(res.Data.Table, 'ConsignmentID')
                  .map((obj) => ({ ConsignmentSubTypeID: obj.ConsignmentID, SubType: obj.ConsignmentType }))
                  .sort((a, b) => a.SubType.localeCompare(b.SubType))
              )
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          })
      }else{
        const body = {
          CompanyID: loginData?.intCompanyID,
          ConsignmentTypeID: selDeliveryType?.id === 2 ? 0 : selConsignmentType?.ConsignmentSubTypeID,
          DeliveryType: selDeliveryType?.id,
          ChargeType: chargeType?.id
        }
        getDeliveryExtraHamaliChrg(body)
          .then((res) => {
            if (res.status === 'Success') {
              const updatedTable = res?.Data?.Table.map(val => ({ ...val, NOPFrom: val.RangeMin,NOPUpto:val.RangeMax,DeliveryUnitCharge:val.ExtHamaliCharge}));
              setReportData(updatedTable)
              setConsignmentTypeOpt(
                removeDuplicatesFromArray(res.Data.Table, 'ConsignmentID')
                  .map((obj) => ({ ConsignmentSubTypeID: obj.ConsignmentID, SubType: obj.ConsignmentType }))
                  .sort((a, b) => a.SubType.localeCompare(b.SubType))
              )
            } else {
              updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'Select_Consignment_Type' })
            }
          })
          .catch((err) => {
            console.log('Error:', err)
          })
      }

    }
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
        <Box sx={{ display: 'flex' }} className="itemButtons">
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`Select_Consignment_Type-${language}-${selConsignmentType?.SubType}`}
              id={'Select_Consignment_Type'}
              label={tr('gsSelCnsType', 'Select Consignment Type')}
              data={consignmentTypesWithAll}
              defaultvalue={selConsignmentType?.SubType || selConsignmentType}
              value={selConsignmentType?.SubType || selConsignmentType}
              onSelect={(val) => {
                setSelConsignmentType(val)
              }}
              idKey={`ConsignmentSubTypeID`}
              dataKey={`SubType`}
              minWidth="250px"
              prevId={`filter-8`}
              nextId={'Select_Delivery_Type'}
              disabled={selDeliveryType?.id === 2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              key={`delivery-filter-${language}-${selDeliveryType?.name}`}
              id={'Select_Delivery_Type'}
              label={tr('gsSelDelType', 'Select Delivery Type')}
              data={translatedDeliveryTypes}
              defaultvalue={selDeliveryType?.name || selDeliveryType}
              onSelect={(val) => {
                setSelDeliveryType(val)
              }}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              prevId={`Select_Consignment_Type`}
              nextId={'Select_Charge_Type'}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              key={`charge-filter-${language}-${chargeType?.name}`}
              id={'Select_Charge_Type'}
              label={tr('gsChgType', 'Select Charge Type')}
              data={translatedChargeTypes}
              defaultvalue={chargeType.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              onSelect={(val) => {
                setChargeType(val)
              }}
              prevId={`Select_Delivery_Type`}
              nextId={'Hamali_Type'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }}>
            <DropDownOA
              key={`hamali-filter-${language}-${hamaliType?.name}`}
              id={'Hamali_Type'}
              label={tr('gsHamaliType', 'Hamali Type')}
              data={translatedHamaliTypes}
              defaultvalue={hamaliType.name}
              idKey={`id`}
              dataKey={`name`}
              minWidth="250px"
              onSelect={(val) => {
                setHamaliType(val)
              }}
              prevId={`Select_Charge_Type`}
              nextId={'LoadBtn'}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '12px' }} className="disabled-wrapper">
            <Button
              variant="contained"
              id="LoadBtn"
              sx={{ paddingY: '7px !important', height: '36px' }}
              className="btn btn-primary"
              onClick={getDeliveryChrgList}
              onKeyDown={(e) => navigation3(e, 'newAddBtn', 'Hamali_Type', () => { })}
            >
              {tr('gsLoad', 'Load')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="outlined"
              id="newAddBtn"
              sx={{ width: '100%' }}
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.deliveryChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, 'editExisting', 'LoadBtn', () => { })}
            >
              {tr('gsAddNew', '+ ADD NEW')}
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx, paddingX: '6px' }} className="disabled-wrapper">
            <Button
              variant="outlined"
              sx={{ width: '100%' }}
              id="editExisting"
              className="receiveitembtn"
              onClick={() => {
                updateModal(true, mdt.updateDeliveryChrgModal)
              }}
              onKeyDown={(e) => navigation3(e, `filter-1`, 'newAddBtn', () => { })}
            >
              {tr('gsEditExist', 'EDIT EXISTING')}
            </Button>
          </Item>
        </Box>
      </Box>
      <Box sx={{ marginTop: '15px' }}>
        <DeliveryChrgTable modalId={mdt.updateDeliveryChrgModal} updateModal={updateModal} reportData={reportData} />
      </Box>
      {showModal && mdt.deliveryChrgModal === modalType ? addDeliveryChrgModal() : null}
      {showModal && mdt.updateDeliveryChrgModal === modalType ? updateDeliveryChrgModal() : null}
      {showModal && mdt.deliveryChrgConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError, getDeliveryChrg,getDeliveryExtraHamaliChrg, updateDeliveryChrg,updateDeliveryExtraHamaliCharge }
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryCharges)
